import styled from 'styled-components';

export const Wrapper = styled.div`
    max-height: 143px;
    label > * {
        pointer-events: none;
        max-height: 143px;

        border-radius: 4px;
        box-shadow: 5px 10px 3px 0px rgba(0, 0, 0, 0), 3px 7px 3px 0px rgba(0, 0, 0, 0.02),
            2px 4px 2px 0px rgba(0, 0, 0, 0.06), 1px 2px 2px 0px rgba(0, 0, 0, 0.1), 0px 0px 1px 0px rgba(0, 0, 0, 0.12);
    }
    input {
        width: 1px;
        height: 0.1;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -99999;
    }
    @media (max-width: 480px) {
        width: 100%;
    }
`;

export const Label = styled.label`
    color: #fff;
    border: 1px solid transparent;
    white-space: nowrap;
    border-radius: 0;
    position: relative;
    cursor: pointer;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    margin-bottom: 0;
    &:hover:after {
        content: 'Upload Image';
        position: absolute;
        line-height: 22px;
        width: 100%;
        text-align: center;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.14);
        color: #fff;
        font-size: 11px;
    }
`;
